import type { Project } from '../../data/projects';
import styles from './ProjectIcon.module.css';

type ProjectIconSize = 'small' | 'medium' | 'large';

interface ProjectIconProps {
    project: Project;
    size?: ProjectIconSize;
}

export default function ProjectIcon({ project, size = 'medium' }: ProjectIconProps) {
    return <img className={`${styles.icon} ${styles[size]}`} src={project.iconSrc} alt="" width={64} height={64} loading="lazy" decoding="async" />;
}
